export function trimObjectValuesWhitespace<T>(obj: T): T {
  if (typeof obj === 'string') {
    return obj.trim() as any;
  }

  if (typeof obj === 'object' && obj !== null) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        obj[key] = trimObjectValuesWhitespace(obj[key]);
      }
    }
  }

  return obj;
}

export function openIosKeyboard() {
  const input = document.createElement('input');
  input.setAttribute('type', 'text');
  input.setAttribute('style', 'position: fixed; top: -100px; left: -100px;');
  document.body.appendChild(input);
  input.focus();
  setTimeout(() => {
    document.body.removeChild(input);
  }, 30 * 1000);
}

export function arrayOfStrings(value: any): string[] {
  if (Array.isArray(value) && value.every((item: any) => typeof item === 'string')) {
    return value;
  }
  return [];
}

export function isNationalId(value: string) {
  const cleanValue = value.replace(/[-\s]/g, '');

  const isValidFormat = cleanValue.match(
    /^(19|20)?\d{2}(01|02|03|04|05|06|07|08|09|10|11|12)((0[1-9])|(1|2)[0-9]|(30|31))\d{4}$/,
  );
  if (!isValidFormat) return false;

  const digits = cleanValue.length === 12 ? cleanValue.slice(2) : cleanValue;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    let num = parseInt(digits[i], 10);
    if (i % 2 === 0) num *= 2;
    if (num > 9) num -= 9;
    sum += num;
  }
  const controlDigit = (10 - (sum % 10)) % 10;

  return controlDigit === parseInt(digits[9], 10);
}

type Route = {
  routePath?: string | string[];
  exact: boolean;
};

export function matchRoute({ routePath, exact }: Route, requestPath: string): Record<string, string> | false {
  if (routePath === undefined) return false;

  // routePath can be an array of paths also, we need to make sure we can handle that
  if (Array.isArray(routePath)) {
    for (const path of routePath) {
      const params = matchRoute({ routePath: path, exact }, requestPath);
      if (params) return params;
    }

    return false;
  }

  // remove empty segments
  const routeSegments = routePath.split('/').filter(Boolean);
  const requestSegments = requestPath.split('/').filter(Boolean);

  const hasOptionalSegments = routeSegments.some((segment) => segment.endsWith('?'));

  if (!hasOptionalSegments) {
    // if number of static segments in the route is greater than the request path, it won't match
    if (routeSegments.length > requestSegments.length) return false;
    // if the route is an exact match, the number of segments must be equal
    if (exact && routeSegments.length !== requestSegments.length) return false;
  }

  const params = {};

  for (let i = 0; i < routeSegments.length; i++) {
    const routeSegment = routeSegments[i];
    const requestSegment = requestSegments[i];

    if (routeSegment.startsWith(':')) {
      // extract dynamic parameter name (for example: ":placeId")
      const paramName = routeSegment.slice(1).replace('?', '');
      const isOptional = routeSegment.endsWith('?');

      if (!requestSegment && !isOptional) {
        // if request path is missing a required param, no match
        return false;
      }

      // add the dynamic parameter to the params object
      params[paramName] = requestSegment || null;
    } else if (routeSegment !== requestSegment) {
      // no match on static segment
      return false;
    }
  }

  // If we reach here, the route matches
  return params;
}
